import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=5e725d3d"
import script from "./custom.vue?vue&type=script&lang=ts"
export * from "./custom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports